// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((componentRegistry) => {
//   /**
//    * General template for fera review
//    */
//   const generalTemplateFareReview = (data) => {
//     return `<div class= data-fera-container="fwid_2pPPtGc" data-product_id="${data?.id}"></div>`;
//   };
  
//   /**
//    * Append template to component
//    */
//   const AppendTemplateProductReview = {
//     name: 'Other - Fera Review - Append Template Product Review',
//     apply() {
//       return {
//         props(props, element) {
//           let productItemData = null;
//           const parentElement = componentRegistry.getNearestParentElm(
//             element,
//             'ProductItem'
//           );
//           const { props: productItemProps } = parentElement?.getParams() || {};
  
//           if (productItemProps)
//             productItemData = productItemProps.product || productItemProps.productData;
//           if (productItemData) props.template = generalTemplateFareReview(productItemData);
  
//           return props;
//         },
//       };
//     },
//   };
  
//   componentRegistry.useComponentPlugin('IntegrationProductReviewFera', AppendTemplateProductReview);
// });

const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add fera review',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                      const feraReviewHTML = `<div class="boost-sd-fera-review" data-fera-widget="product_collection_rating" data-fera-container="fwid_2pPPtGc" data-product_id="${productData?.id}"></div>`;
                      if (!productItem.querySelector('.boost-sd-fera-review')) {
                         productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('afterend', feraReviewHTML);
                      }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);
